import {get, post} from '@/utils/fetch';

import {ASYNC_UILS} from '@/dicts/fetchUrls';
import {SELF_TOPIC_CONTAINER_TYPE_MIX} from '@/dicts/modelConsts';
import {getPageBaseUrl} from '@/utils/utils';

const prefxiAPI = process.env.PREFIX_ASYNC_API || getPageBaseUrl();

export interface ubcProps {
    page: string;
    value: string;
    sfRef?: string;
    pageSourceId: string;
    pageType: string;
    valueId: number;
    valueTitle: string;
}

interface TopicQuery {
    id?: string;
    sa?: string;
    sf_ch?: string;
    preview?: boolean;
}

interface TopicItemQuery {
    id?: string;
    moduleId?: number;
    pageSize: number;
    pageNo: number;
    sf_ch?: string;
    preview?: boolean;
    category?: string;
}

interface TopicVpQuery {
    id: string;
    sf_ch?: string;
    moduleId: number;
}


export interface TopicResponseData {
    channelId?: string;
    templateId: number;
    channelName: string;
    channelShareTitle?: string;
    channelShareSubTitle?: string;
    channelShareLogo?: string;
    moduleList: TopicModule[];
    channelBusinessLine: number;
    pageBgc?: string;
}
export interface TopicModule {
    moduleId?: number;
    channelId?: string;
    moduleName?: string;
    isShowTitle?: number; // 1显示 2隐藏 -判断1就显示
    moreUrl?: string;
    moduleEnName?: string;
    moduleType?: number;
    moduleStyle?: number;
    moduleSubTitle?: string;
    moduleMaxColumns?: number; // 列
    moduleMaxRows?: number; // 行
    count?: number; // 行
    itemList?: TopicItemInfo[];
    subModuleList?: TopicModule[];
    businessLine?: string;
    moduleBgc?: string;
    moduleFillet?: number;
    moduleSpace?: number;
    moduleSpaceBack?: number;
    moduleOpenRows?: number; // 列表每次展开的数量
    moduleSelectColor?: string; // 自定义文字颜色
}
export interface TopicItemInfo {
    link?: string;
    itemId: number;
    moduleId: number;
    channelId: number;
    title?: string;
    fieldValue?: TopicFieldInfo;
}
export interface TopicFieldInfo {
    readNum?: string;
    selfName?: string;
    thirdLogo?: string;
    thirdUrl?: string; //  头图跳转链接
    thirdName?: string;
    floatBtnText?: string;
    floatBtnUrl?: string;

    title?: string;
    titleLine?: number; // title最多几行

    link?: string;
    swanUrl?: string;

    // 视频时长
    duration?: string;

    // 图片
    img?: string;
    logo?: string;


    // flow 数据
    image?: string; // 右图
    expertDepart?: string; // 整形科
    expertHospital?: string; // 中国医学科学院整形外科医院
    expertName?: string; // 李强
    expertPortrait?: string; // 专家头像
    expertTitle?: string; // 主任医师
    hospitalLevel?: string; // 三甲
    type?: number; // 单列小图信息流-1是文章、2是视频


    bgImage?: string;
    titleImage?: string;


    abstract?: string;

    subTitle?: string;

    isHot?: string;

    // 一级导航栏数据
    showModuleList?: NaviItem[];

    // 专家列表数据
    department?: string;
    expertid?: string;
    goodat?: string;
    guahaostatus?: string;
    hospital?: string;
    name?: string;
    portrait?: string;
    wenzhenstatus?: string;

    // 文字飘蓝
    keyword?: string;

    // 弹窗模块数据
    content?: string;
    desc?: string;
}

export interface NaviItem {
    checked?: boolean;
    expand?: boolean;
    moduleId: string;
    title?: string;
    children?: NaviChildItem[];
}

export interface ItemQuery {
    id?: string;
    moduleId?: number;
    pageSize: number;
    pageNo: number;
    sf_ch?: string;
    preview?: boolean;
}

export interface TopicShareQuery {
    wxAppKey: string;
    url: string;
}

export interface NaviChildItem {
    checked?: boolean;
    expand?: boolean;
    moduleId: string;
    title?: string;
    parentModulId?: string;
    child?: boolean;
}


export interface TopicItemResponse {
    count: number;
    list: TopicItemInfo[];
}

export interface TopicPvResponse {
    pv: string;
}

export interface TopicShareResponse {
    appId: string;
    timestamp: string;
    nonceStr: string;
    signature: string;
    url: string;
}

export const getTopicInfo = async (query: TopicQuery) => {
    const topiclist = await get<TopicResponseData, TopicQuery>(
        `${prefxiAPI}${query.preview
            ? ASYNC_UILS.TOPIC_PREVIEW
            : ASYNC_UILS.TOPIC_VIEW}`, query
    );

    if (topiclist.moduleList && topiclist.moduleList.length > 0) {
        // eslint-disable-next-line array-callback-return
        topiclist.moduleList?.map(module => {
            // 过滤容器模块、平滑模式下空内容的sublist
            if (module.moduleEnName === 'selfTopicContainer' && module.moduleStyle === SELF_TOPIC_CONTAINER_TYPE_MIX) {
                if (module.subModuleList && module.subModuleList.length > 0) {
                    module.subModuleList = module.subModuleList.filter(item => {
                        let contentNumber = 0;
                        if (item.subModuleList && item.subModuleList.length > 0) {
                            item.subModuleList.forEach(subItem => {
                                if (subItem.itemList && subItem.itemList.length > 0) {
                                    contentNumber++;
                                }
                            });
                        }
                        if (item.itemList && item.itemList.length > 0) {
                            contentNumber++;
                        }
                        return contentNumber > 0;
                    });
                }
            }
        });
    }
    return topiclist;
};

export const getTopicItemlist = async (query: TopicItemQuery) => {
    const topicItemlist = await post<TopicItemResponse, TopicItemQuery>(
        `${prefxiAPI}${query.preview ? ASYNC_UILS.TOPIC_PREVIEW_ITEMLIST : ASYNC_UILS.TOPIC_ITEMLIST}`, query);
    return topicItemlist;
};

export const getTopicVp = async (query: TopicVpQuery) => {
    const topicVp = await post<TopicPvResponse, TopicVpQuery>(`${prefxiAPI}${ASYNC_UILS.TOPIC_VP}`, query);
    return topicVp;
};

// 上线前更改！
export const getTopicShareInfo = async (query: TopicShareQuery) => {
    // eslint-disable-next-line max-len
    const topicShare = await post<TopicShareResponse, TopicShareQuery>(`${prefxiAPI}${ASYNC_UILS.TOPIC_SHARE}`, query);
    return topicShare;
};
